// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import delay from '../../../../common/utils/lib/delay';

// Components
import Tick from '../../animations/Tick';

// Styles
import './SuccessTransitionButton.scss';

const SuccessTransitionButton = (props) => {
    const { children, className, onClick, successText } = props;

    const buttonRef = React.useRef();

    const onClickHandler = async (event) => {
        onClick(event);

        if (!buttonRef.current) return;

        buttonRef.current.classList.add('transition-in');
        await delay(100);
        buttonRef.current.classList.add('transition-steady');
        await delay(400);
        buttonRef.current.classList.add('transition-out');
        await delay(100);

        buttonRef.current.classList.remove('transition-in', 'transition-steady', 'transition-out');
    };

    return (
        <button ref={buttonRef} className={classNames('SuccessTransitionButton', className)} onClick={onClickHandler}>
            <span className="resting">{children}</span>
            <span className="success-transition">
                <Tick /> {successText}
            </span>
        </button>
    );
};

SuccessTransitionButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
    className: PropTypes.string,
    successText: PropTypes.string,
    onClick: PropTypes.func,
};

export default SuccessTransitionButton;
